import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid';
import jaLocale from '@fullcalendar/core/locales/ja';
// dateClickに必要
import interactionPlugin from '@fullcalendar/interaction';
var moment = require("moment");
// 参考URL
// https://qiita.com/shira79/items/472f7d826d0219e2ebbf


export function calendar() {
	var oCalendarBody = document.getElementById('calendar-body');
	$.ajax({
		// ここで選択した日付のデータを取得
		url: "/mypage/company/temporary-closed/getCloseDay",
		type:'GET',
		datatype:'json',
		timeout:30000
	}).
	done(function(oData){
		if(oData.status == 'success'){
			var oCalendarEvents = [];
			$.each(oData.close_days, function(index, val) {
				oCalendarEvents.push({
					rendering: 'background',
					color: 'transparent',
					start: val['close_day']
				});
			});
			// headerToolbar :
			var oCalendar = new Calendar(oCalendarBody, {
				headerToolbar : {
					left: 'title',
					// center: 'title',
					right: 'prev,next'
					// right: 'dayGridMonth,listWeek'
				},
				plugins: [ dayGridPlugin, interactionPlugin ],
				locales: [ jaLocale ],
				locale: 'ja',
				contentHeight:"auto",
				events: oCalendarEvents,
				// 日付の「日」を削除
				dayCellContent: function(e) {
					e.dayNumberText = e.dayNumberText.replace('日', '');
				},
				dateClick: function(oData) {

					// 今日の日付
					var now = new Date();
					var y = now.getFullYear();
					var m = now.getMonth() + 1;
					var d = now.getDate();
					var mm = ('0' + m).slice(-2);
					var dd = ('0' + d).slice(-2);
					var today = y+mm+dd;
					$('.js-date').val(oData.dateStr);
					// 今日以降をクリックで実行
					var check = moment(oData.dateStr).format('YMMDD');
					if(check >= today) {
						// ローディング開始
						$("body").prepend(sLoadingHtml2).hide().fadeIn(100);
						// input用の日付
						var dateData = moment(oData.dateStr).format('Y-MM-DD');
						$('input.js-date').val(dateData);
						// カレンダー日付をクリックしてから右側表示
						// $('.js-reserve-content').show();
						// 選択は1日だけとする
						$(".calendar .date-highlight").removeClass("date-highlight");
						$(oData.dayEl).addClass('date-highlight');
						var date = moment(oData.dateStr).format('M月D日');

						if (moment().isSameOrBefore(oData.dateStr, 'day')){
							// 今日以降のみ予約枠を読み込む
							$.ajax({
								// ここで選択した日付のデータを取得
								url: "/mypage/company/temporary-closed/getCloseTime/" + oData.dateStr,
								type:'GET',
								datatype:'json',
								timeout:30000
							}).
							done(function(oData){
								if(oData.status == 'success'){
									// 作業開始時間
									// 選択した日付のデータを取得し、
									// データが入っていたらそのoptionをselectedする
									function select() {
										// 見出し用の日付
										$('.js-reserve-heading').text(date);
										for (var i=0; i<=2; i++) {
											// if(oData.close_times.length ) {
											if(oData.close_times[i] ) {
												var selectDay = $('.js-date').val();
												var closedStart = oData.close_times[i]['closed_start'];
												var closedStart = closedStart.replace(selectDay+' ', '');
												$('select[name="closed-start-'+ i +'"]').val(closedStart);
											}else {
												// データが入っていなかったらselectedを解除
												$('select[name="closed-start-'+ i +'"] option:selected').prop('selected', false);
											}
										}
										// 作業終了時間
										for (var i=0; i<=2; i++) {
											// if(oData.close_times.length) {
											if(oData.close_times[i]) {
												var selectDay = $('.js-date').val();
												var closedEnd = oData.close_times[i]['closed_end'].replace(selectDay+' ', '');
												$('select[name="closed-end-'+ i +'"]').val(closedEnd);
											}else{
												$('select[name="closed-end-'+ i +'"] option:selected').prop('selected', false);
											}
										}
									}
									/* **************************
										日付を選択したらスクロール
									*/
									smoothScroll()
									function smoothScroll() {
										var screenWidth = window.innerWidth;
										var headerHight = 0;//ヘッダの高さ
										if (screenWidth >= 1079) {
											headerHight = 85;
										}else if(screenWidth <= 1080 ) {
											headerHight = 60;
										}
										var delayTime = 500;
										var position = $('.reserve-box').offset().top - headerHight - 30;
										if(screenWidth <= 768 ) {
											$("html, body").delay(delayTime).animate({ scrollTop: position }, 500);
										}
									}
									function loadingEnd() {
										// ローディング終了
										$("#loadingOverlay").fadeOut(500, function () {
												$(this).remove();
										})
									}
									$.when(
										$('.js-reserve-content').hide(),
										select()
										).done(function() {
										$('.js-reserve-content').show(),
										loadingEnd()
									}).fail(function() {
											console.log('エラー');
									});
								} else {
									$.toast({
										heading: 'データの読み込みの際にエラーが発生しました。',
										text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
										showHideTransition: 'slide',
										icon: 'error',
										position: 'bottom-right',
										hideAfter: 6000
									});
								}
							}).
							fail(function(oData, sTextStatus, sErrorThrown){
								$.toast({
									heading: 'データの読み込みに失敗しました',
									text: 'お手数ですが、再度お試しください。',
									showHideTransition: 'slide',
									icon: 'error',
									position: 'bottom-right',
									hideAfter: 6000
								});
							}).
							always(function(oData){
							});
						}
					}else{
						// 過去を選択したら時間選択を非表示
						$('.js-reserve-content').hide();
					}
				},
				// eventClick: function(oData) {
				// 	// 今日の日付
				// 	var now = new Date();
				// 	var y = now.getFullYear();
				// 	var m = now.getMonth() + 1;
				// 	var d = now.getDate();
				// 	var mm = ('0' + m).slice(-2);
				// 	var dd = ('0' + d).slice(-2);
				// 	var today = y+mm+dd;

				// 	$('.js-date').val(oData.dateStr);

				// 	// 今日以降をクリックで実行
				// 	var check = moment(oData.dateStr).format('YMMDD');
				// 	if(check >= today) {
				// 		// 見出し用の日付
				// 		var date = moment(oData.dateStr).format('M月D日');
				// 		$('.js-reserve-heading').text(date);
				// 		// input用の日付
				// 		var dateData = moment(oData.dateStr).format('Y-MM-DD');
				// 		$('input.js-date').val(dateData);
				// 		// カレンダー日付をクリックしてから右側表示
				// 		$('.js-reserve-content').show();
				// 		// 選択は1日だけとする
				// 		$(".calendar .date-highlight").removeClass("date-highlight");
				// 		$(oData.dayEl).addClass('date-highlight');

				// 		if (moment().isSameOrBefore(oData.dateStr, 'day')){
				// 			// 今日以降のみ予約枠を読み込む
				// 			$.ajax({
				// 				// ここで選択した日付のデータを取得
				// 				url: "/mypage/company/temporary-closed/getCloseTime/" + oData.dateStr,
				// 				type:'GET',
				// 				datatype:'json',
				// 				timeout:30000
				// 			}).
				// 			done(function(oData){
				// 				console.log(oData);
				// 				if(oData.status == 'success'){
				// 					// 作業開始時間
				// 					// 選択した日付のデータを取得し、
				// 					// データが入っていたらそのoptionをselectedする
				// 					for (var i=0; i<=2; i++) {
				// 						// if(oData.close_times.length ) {
				// 						if(oData.close_times[i] ) {
				// 							var selectDay = $('.js-date').val();
				// 							var closedStart = oData.close_times[i]['closed_start'];
				// 							var closedStart = closedStart.replace(selectDay+' ', '');
				// 							$('select[name="closed-start-'+ i +'"]').val(closedStart);
				// 						}else {
				// 							// データが入っていなかったらselectedを解除
				// 							$('select[name="closed-start-'+ i +'"] option:selected').prop('selected', false);
				// 						}
				// 					}
				// 					// 作業終了時間
				// 					for (var i=0; i<=2; i++) {
				// 						// if(oData.close_times.length) {
				// 						if(oData.close_times[i]) {
				// 							var selectDay = $('.js-date').val();
				// 							var closedEnd = oData.close_times[i]['closed_end'].replace(selectDay+' ', '');
				// 							$('select[name="closed-end-'+ i +'"]').val(closedEnd);
				// 						}else{
				// 							$('select[name="closed-end-'+ i +'"] option:selected').prop('selected', false);
				// 						}
				// 					}
				// 				} else {
				// 					$.toast({
				// 						heading: 'データの読み込みに失敗しました',
				// 						text: 'お手数ですが、再度お試しください',
				// 						showHideTransition: 'slide',
				// 						icon: 'error',
				// 						position: 'bottom-right',
				// 						hideAfter: false
				// 					});
				// 				}
				// 			}).
				// 			fail(function(oData, sTextStatus, sErrorThrown){
				// 				$.toast({
				// 					heading: 'データの読み込みに失敗しました',
				// 					text: 'お手数ですが、再度お試しください。',
				// 					showHideTransition: 'slide',
				// 					icon: 'error',
				// 					position: 'bottom-right',
				// 					hideAfter: 6000
				// 				});
				// 			}).
				// 			always(function(oData){});
				// 		}
				// 	}else{
				// 		// 過去を選択したら時間選択を非表示
				// 		$('.js-reserve-content').hide();
				// 	}
				// },
			});
			$('.fc-bg').removeClass('fc-today');
			oCalendar.render();
		}else{
			$.toast({
				heading: 'データの読み込みの際にエラーが発生しました。',
				text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
				showHideTransition: 'slide',
				icon: 'error',
				position: 'bottom-right',
				hideAfter: 6000
			});
		}
	}).
	fail(function(oData, sTextStatus, sErrorThrown){
		$.toast({
			heading: 'データの読み込みに失敗しました',
			text: 'お手数ですが、再度お試しください。',
			showHideTransition: 'slide',
			icon: 'error',
			position: 'bottom-right',
			hideAfter: 6000
		});
	}).
	always(function(oData){});
	// カレンダーレンダリング
}
$(function(){
	if ($('.temporary-closed').length > 0){
		/*
		ページ表示時
		*/
		// カレンダー本体
		calendar();

		// ローディング終了
		$("#loadingOverlay").fadeOut(500, function () {
					$(this).remove();
		})
	}
});

	$(document).on(oEventNames.end, '.js-post-btn', function (event) {
			if (!bIsScrolling) {
				event.preventDefault();
				var selectDay = $('.js-date').val();
				// postされる時間の配列
				var aStartTime = [];
				// 選択した時間がどんな状態か示すための配列
				var aSelected = [];
				// 開始時間だけの配列
				var aSelectedStart = [];
				// 終了時間だけの配列
				var aSelectedClose = [];

				// selectから選択し値を取得
				$('select.js-start-time').each(function(index) {
					var closeTime = $(this).parent('.input-item').next('.input-item').find('.js-close-time').val();
					if(closeTime !== '') {
						aSelectedClose.push(closeTime);
					}

					var startTime = $(this).val();
					if(startTime !== '') {
						aSelectedStart.push(startTime);
					}
					if(startTime && closeTime) {
						// 開始時間と終了時間が両方入力された時
						aStartTime.push({start: startTime, end: closeTime});
						if(startTime == closeTime) {
							// 同じ値の時
							aSelected.push('two');
						}
					}else if(!startTime && !closeTime) {
						// どちらも入っていない時
						// aSelected.push();
					}else{
						// どちらかが入っている時
						aSelected.push('one');
					}
				});
				// 配列に重複する値があったらtrueを返す関数
				// https://pisuke-code.com/js-check-duplicated-array-values/
				function existsSameValue(a){
					var s = new Set(a);
					return s.size != a.length;
				}
				// 他の開始時間・終了時間と値が重複した時の判定
				if (aSelectedStart.length > 1 && aSelectedClose.length > 1) {
					if(existsSameValue(aSelectedStart) && existsSameValue(aSelectedClose)) {
						aSelected.push('duplicate');
						// console.log('開始時間と終了時間で重複がありました。');
					}else if(!existsSameValue(aSelectedStart) && existsSameValue(aSelectedClose)) {
						aSelected.push('duplicate');
						// console.log('終了時間に重複がありました。');
					}else if(existsSameValue(aSelectedStart) && !existsSameValue(aSelectedClose)) {
						aSelected.push('duplicate');
						// console.log('開始時間に重複がありました。');
					}else{
					// console.log('重複はありません');
					}
				}

				// postするデータ
				let data = {
					"Date": selectDay,
					"CloseTime": aStartTime
				}
				if( $.inArray('one', aSelected) !== -1 ){
					// 配列aSelectedにoneが入っていたら
					$.toast({
						heading: '再設定をお願いいたします',
						text: '開始時間と終了時間の両方を設定ください。',
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: false,
						stack : 1,
					});
				} else if( $.inArray('duplicate', aSelected) !== -1 ) {
					// 配列aSelectedにduplicateが入っていたら
					$.toast({
						heading: '再設定をお願いいたします',
						text: '開始時間と終了時間は他の設定と重複して設定できません。',
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: false,
						stack : 1,
					});
				} else if( $.inArray('two', aSelected) !== -1 ) {
					// 配列aSelectedにtwoが入っていたら
					$.toast({
						heading: '再設定をお願いいたします',
						text: '開始時間と終了時間に同じ時間は設定できません。',
						showHideTransition: 'slide',
						icon: 'error',
						position: 'bottom-right',
						hideAfter: false,
						stack : 1,
					});
				}else{
					// 入っていなかったら
					$.ajax({
						type: "POST",
						url: "/mypage/company/temporary-closed/updateCloseTime",
						data: JSON.stringify(data),
						contentType: "application/json; charset=utf-8",
						dataType : "json",
						cache: false,
						processData: false,
						headers: {
								'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						}
					}).
					done(function(oData){
						if(oData.status == 'success'){
							// ローディング開始
							// $("body").prepend(sLoadingHtml2).hide().fadeIn(100);
							$.toast({
								heading: '設定を完了しました',
								showHideTransition: 'slide',
								icon: 'success',
								position: 'bottom-right',
								hideAfter: 6000,
								stack : 1,
							});
							calendar();
						} else if(oData.status == 'error'){
							$.toast({
								heading: '再設定をお願いいたします',
								text: '休業終了時間は休業開始時間より前の時間は設定できませんので、再入力をお願いいたします。',
								showHideTransition: 'slide',
								icon: 'error',
								position: 'bottom-right',
								hideAfter: false,
								stack : 1,
							});
						}
					}).
					fail(function(oData){
						if(oData.status == 'error'){
							$.toast({
								heading: 'データの読み込みに失敗しました',
								text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
								showHideTransition: 'slide',
								icon: 'error',
								position: 'bottom-right',
								hideAfter: 6000,
								stack : 1,
							});
						} else {
							$.toast({
								heading: 'データの読み込みに失敗しました',
								text: 'お手数ですが、再度お試しいただくか、運営までお問い合わせくださいませ。',
								showHideTransition: 'slide',
								icon: 'error',
								position: 'bottom-right',
								hideAfter: 6000,
								stack : 1,
							});
						}
					}).
					always(function(oData){
						// ローディング終了
						// $("#loadingOverlay").fadeOut(500, function () {
						// 		$(this).remove();
						// })
					});
				}
			}
  });